module.exports = __webpack_public_path__ + "img/元素1.d611dea6.png";